var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#215fd7",
    height: 40,
    width: 20,
    y: 30,
    x: 10
  }, /*#__PURE__*/React.createElement("animate", {
    begin: -1.875,
    values: "1;0.2;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "3.125s",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#4daff1",
    height: 40,
    width: 20,
    y: 30,
    x: 30
  }, /*#__PURE__*/React.createElement("animate", {
    begin: -1.25,
    values: "1;0.2;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "3.125s",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#6ad0b1",
    height: 40,
    width: 20,
    y: 30,
    x: 50
  }, /*#__PURE__*/React.createElement("animate", {
    begin: -0.625,
    values: "1;0.2;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "3.125s",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#86f4e0",
    height: 40,
    width: 20,
    y: 30,
    x: 70
  }, /*#__PURE__*/React.createElement("animate", {
    begin: -3.125,
    values: "1;0.2;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "3.125s",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.bfc172bb427640383e4deadab5191222.svg";
export { ForwardRef as ReactComponent };